<template>
  <div class="c-editor">
    <div class="c-editor__left">
      <panel-header
        :title="scenarioId ? 'Редактирование сценария' : 'Создание сценария'"
        :with-back-button="true"
        @back="back"
      />
      <div class="c-editor__container">
        <editor-controls />
      </div>
    </div>
    <div class="c-editor__right" v-if="activeEventId">
      <event-attributes />
    </div>
  </div>
</template>

<script>
import PanelHeader from "@/components/calculations/panel-header/panel-header";
import EditorControls from "@/components/calculations/editor/editor-controls";
import EventAttributes from "@/components/calculations/editor/event-attributes";

export default {
  components: {
    PanelHeader,
    EditorControls,
    EventAttributes
  },
  computed: {
    activeEventId() {
      return this.$store.state.calculations.activeEventId;
    },
    scenarioId() {
      return this.$route.query.id;
    }
  },
  methods: {
    back() {
      const { calculating, loadingLayers } = this.$store.state.calculations;
      if (loadingLayers.length) return;
      if (calculating) return;

      const { modelId } = this.$route.params;

      this.$router.push(`/app/calculations/${modelId}/list`);
    }
  }
};
</script>

<style lang="scss">
.c-editor {
  display: flex;
  height: calc(100vh - 48px);

  &__left {
    display: flex;
    flex-direction: column;
    width: 260px;
  }

  &__right {
    display: flex;
    flex-direction: column;
    width: 260px;
    background-color: var(--bg_panel_secondary) !important;
  }

  &__container {
    display: flex;
    flex-direction: column;
    flex: 1;
    height: 0px;
  }
}
</style>
